export default __webpack_public_path__ + "media/37a8b3a1d00c99f979421807ac07c96cf268e4cf0e81fccbf177f33dfc1cdcbb.svg";